import { effect, inject, Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { IapService } from '../services/iap.service';

/** Keeps RevenueCat app user id in sync with Supabase auth on native builds. */
@Injectable({ providedIn: 'root' })
export class IapAuthBridgeService {
  private readonly auth = inject(AuthService);
  private readonly iap = inject(IapService);

  constructor() {
    void this.iap.initialize();

    effect(() => {
      const userId = this.auth.user()?.id ?? null;
      if (!this.iap.isNativePlatform()) {
        return;
      }
      void this.iap.syncUser(userId);
    });
  }
}
